import { Alert, Typography } from "@mui/material";
import React, { FC } from "react";

interface IPropsAlert {
  variant?: "standard" | "filled" | "outlined";
  severity?: "success" | "info" | "warning" | "error";
  message?: string;
}

export const CustomAlert: FC<IPropsAlert> = ({
  variant,
  severity,
  message,
}) => {
  return (
    <Alert variant={variant ? variant : "filled"} severity={severity ? severity : "success"} sx={{ marginTop: 1 }}>
      <Typography className="text-description">{message}</Typography>
    </Alert>
  );
};
